/**
 * Reseller Grid Section
 * Handles category filtering for reseller cards
 */

class ResellerGrid extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll('.reseller-grid__tab');
    this.cards = this.querySelectorAll('.reseller-grid__card');
    this.init();
  }

  init() {
    // Fix auto-translated labels: set text from data attributes
    this.querySelectorAll('[data-cat-label]').forEach((el) => {
      const span = el.querySelector('span');
      if (span) {
        span.textContent = el.dataset.catLabel;
      } else {
        el.textContent = el.dataset.catLabel;
      }
    });

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', this.handleTabClick.bind(this));
    });
  }

  handleTabClick(event) {
    const clickedTab = event.currentTarget;
    const category = clickedTab.dataset.category;

    this.updateTabs(clickedTab);
    this.filterCards(category);
  }

  updateTabs(activeTab) {
    this.tabs.forEach((tab) => {
      tab.classList.remove('reseller-grid__tab--active');
      tab.setAttribute('aria-selected', 'false');
    });

    activeTab.classList.add('reseller-grid__tab--active');
    activeTab.setAttribute('aria-selected', 'true');
  }

  filterCards(category) {
    this.cards.forEach((card) => {
      const cardCategory = card.dataset.category;

      if (category === 'all' || cardCategory === category) {
        card.classList.remove('hidden');
        card.style.display = '';
      } else {
        card.classList.add('hidden');
        card.style.display = 'none';
      }
    });
  }
}

if (!customElements.get('reseller-grid')) {
  customElements.define('reseller-grid', ResellerGrid);
}

document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-section-type="reseller-grid"]');

  // Fix auto-translated labels: set text from data attributes
  document.querySelectorAll('[data-cat-label]').forEach((el) => {
    const span = el.querySelector('span');
    if (span) {
      span.textContent = el.dataset.catLabel;
    } else {
      el.textContent = el.dataset.catLabel;
    }
  });

  sections.forEach((section) => {
    if (!section.hasAttribute('data-initialized')) {
      const tabs = section.querySelectorAll('.reseller-grid__tab');
      const cards = section.querySelectorAll('.reseller-grid__card');

      tabs.forEach((tab) => {
        tab.addEventListener('click', (e) => {
          const category = e.currentTarget.dataset.category;

          tabs.forEach((t) => {
            t.classList.remove('reseller-grid__tab--active');
            t.setAttribute('aria-selected', 'false');
          });

          e.currentTarget.classList.add('reseller-grid__tab--active');
          e.currentTarget.setAttribute('aria-selected', 'true');

          cards.forEach((card) => {
            const cardCategory = card.dataset.category;
            if (category === 'all' || cardCategory === category) {
              card.classList.remove('hidden');
              card.style.display = '';
            } else {
              card.classList.add('hidden');
              card.style.display = 'none';
            }
          });
        });
      });

      section.setAttribute('data-initialized', 'true');
    }
  });
});
